import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import './Legal.css'

export default function RefundPolicy() {
  return (
    <div className="legal-page">
      <Header />
      
      <main className="legal-content">
        <div className="container">
          <Link to="/" className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          
          <div className="legal-card">
            <h1>Refund & Cancellation Policy</h1>
            <p className="legal-date">Last updated: December 2024</p>
            
            <section className="legal-section">
              <h2>1. Service Confirmation</h2>
              <p>
                Once the customer confirms the service and payment is made, work begins 
                immediately on your digital vCard or other requested services.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>2. Refund Policy</h2>
              <p>
                Digital services (website, vCard, branding) cannot be fully refunded once 
                work has started.
              </p>
              <div className="policy-highlight">
                <p>
                  <strong>Partial refunds</strong> may be provided only if no major work 
                  has been completed. Each request will be evaluated on a case-by-case basis.
                </p>
              </div>
            </section>
            
            <section className="legal-section">
              <h2>3. Cancellation</h2>
              <ul>
                <li>
                  <strong>Before work starts:</strong> If you want to cancel before work 
                  begins, contact us immediately for a full refund.
                </li>
                <li>
                  <strong>After work starts:</strong> If work has already begun, cancellation 
                  charges may apply based on the progress made.
                </li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>4. Subscription Cancellation</h2>
              <p>
                For subscription-based services:
              </p>
              <ul>
                <li>You can cancel your subscription anytime from your dashboard</li>
                <li>Access continues until the end of your billing period</li>
                <li>No refunds for partial months or unused time</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>5. Contact</h2>
              <p>
                For refund or cancellation requests, contact us at:
              </p>
              <ul className="contact-list">
                <li>Email: support@santhoshsharuk.me</li>
                <li>Phone: +91 81109 60489</li>
              </ul>
              <p className="response-time">
                We aim to respond to all refund requests within 2-3 business days.
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}
